export const CStepsFragment = `
  fragment steps on steps_MatrixField {
    ... on steps_block_Entry {
      heading
      subHeading
      steps: stepItems {
        ... on steps_Entry {
          stepTitle
          stepContent
          image {
            url @transform(mode: "crop", width: 90, immediately: true)
            title
            width
            height
          }
        }
      }
      ctaSection {
        ... on ctaSection_Entry {
          sectionTitle
          cta {
            type
            url
            text
            target
          }
        }
      }
    }
  }
`
